import { useState } from "react";
import { demoComments, type CommentItem } from "@/mocks/comments";

interface CommentSectionProps {
  count: number;
}

export default function CommentSection({ count }: CommentSectionProps) {
  const [list, setList] = useState<CommentItem[]>(demoComments);
  const [input, setInput] = useState("");
  const [tip, setTip] = useState("");
  const [likedIds, setLikedIds] = useState<string[]>([]);

  const submit = () => {
    const text = input.trim();
    if (!text) {
      setTip("请输入评论内容");
      window.setTimeout(() => setTip(""), 2000);
      return;
    }
    setList((prev) => [
      {
        id: `local-${Date.now()}`,
        user: "我",
        avatar:
          "https://readdy.ai/api/search-image?query=Neutral%20young%20asian%20person%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20light%20gray%20background%2C%20clean%20simple%20profile%20photo&width=80&height=80&seq=ks-cm-me&orientation=squarish",
        content: text,
        time: "刚刚",
        likes: 0,
      },
      ...prev,
    ]);
    setInput("");
    setTip("演示评论，仅在本页显示，未接入评论后端");
    window.setTimeout(() => setTip(""), 2600);
  };

  const toggleLike = (id: string) => {
    setLikedIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-6">
      <h2 className="text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
        <i className="ri-chat-3-line text-primary-500"></i>
        评论 <span className="text-sm font-normal text-foreground-400">{count}</span>
      </h2>

      <div className="flex items-start gap-3 mb-5">
        <span className="w-9 h-9 rounded-full overflow-hidden bg-background-200 shrink-0">
          <img
            src="https://readdy.ai/api/search-image?query=Neutral%20young%20asian%20person%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20light%20gray%20background%2C%20clean%20simple%20profile%20photo&width=80&height=80&seq=ks-cm-me&orientation=squarish"
            alt="我"
            className="w-full h-full object-cover object-top"
          />
        </span>
        <div className="flex-1">
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value.slice(0, 500))}
            rows={3}
            placeholder="友善发言，一起聊聊这条视频吧"
            className="w-full rounded-lg border border-background-200 bg-background-100 px-3 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:bg-background-50 resize-none transition-colors"
          ></textarea>
          <div className="flex items-center justify-between mt-2">
            <span className="text-xs text-foreground-400">{input.length}/500</span>
            <button
              type="button"
              onClick={submit}
              className="h-9 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              发布评论
            </button>
          </div>
          {tip && (
            <p className="text-xs text-accent-600 mt-2 flex items-center gap-1 animate-fade-in">
              <i className="ri-information-line"></i>
              {tip}
            </p>
          )}
        </div>
      </div>

      <div className="space-y-5">
        {list.map((c) => (
          <div key={c.id} className="flex items-start gap-3">
            <span className="w-9 h-9 rounded-full overflow-hidden bg-background-200 shrink-0">
              <img src={c.avatar} alt={c.user} className="w-full h-full object-cover object-top" />
            </span>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-foreground-800">{c.user}</span>
                <span className="text-xs text-foreground-400">{c.time}</span>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mt-1">{c.content}</p>
              <button
                type="button"
                onClick={() => toggleLike(c.id)}
                className={`flex items-center gap-1 text-xs mt-1.5 transition-colors cursor-pointer ${
                  likedIds.includes(c.id) ? "text-primary-600" : "text-foreground-400 hover:text-primary-600"
                }`}
              >
                <i className={likedIds.includes(c.id) ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                {c.likes + (likedIds.includes(c.id) ? 1 : 0)}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}